import { Routes, Route, Navigate } from "react-router-dom";
import Admission from "./components/admission/Admission";
import LoginContainer from "./containers/LoginContainer";
import PaymentStatus from "./components/paymentStatus/PaymentStatus";
import UploadStudentsFeeDetailsContainer from "./containers/UploadStudentsDetailsContainer";
import ViewStudentDetailsContainer from "./containers/ViewStudentDetailsContainer";
import Checkout from "./components/checkout/Checkout";
import RazorPay from "./components/payment/Razorpay"
import "bootstrap/dist/css/bootstrap.min.css";
import OfflinePaymentStatus from "./components/offlinePaymentStatus/OfflinePaymentStatus";
import AppContext from "./storage/AppContext";
import { useContext } from "react";
import Notifications from "./components/notifications/Notifications";
import Announcements from "./components/announcements/Announcements";
import "./App.css"
import NativePaymentStatus from "./components/paymentStatus/NativePaymentStatus";
import Templates from "./components/templates/Templates";
import SaveTemplate from "./components/templates/SaveTemplate";
import EditTemplate from "./components/templates/EditTemplate";
import AudioFiles from "./components/MediaFiles/SaveMediaFiles";
import SaveMediaFiles from "./components/MediaFiles/SaveMediaFiles";
import ViewMediaFiles from "./components/MediaFiles/ViewMediaFiles";

function App() {
  const appContext = useContext(AppContext);
  const userDetails = appContext?.userDetails

  if(userDetails?.active === undefined) {
    return (
      <Routes>
        <Route exact path="/" element={<LoginContainer/>}/>
        <Route exact path="/admission" element={<Admission />} />
        <Route exact path="/paymentStatus/:admId/:academicYear" element={<PaymentStatus />} />
        <Route exact path="/checkout" element={<Checkout />} />
        <Route exact path="/payment/:admId/:academicYear" element={<RazorPay />} />
        <Route exact path="/offlinePaymentStatus" element={<OfflinePaymentStatus />} />
        <Route exact path="/nativePaymentStatus/:admId/:academicYear" element={<NativePaymentStatus />}/>
        <Route exact path="/viewMedia" element={<ViewMediaFiles />} />
        <Route path="*" element={<Navigate to="/" replace />}/>
      </Routes>
    )
  }

  if(userDetails?.data?.role !== "Admin"){
    return (
      <div>
        <Routes>
          <Route exact path="/" element={<LoginContainer/>}/>
          <Route exact path="/viewStudentDetails" element={<ViewStudentDetailsContainer />} />
          <Route exact path="/notifications" element={<Notifications />} />
          <Route exact path="/templates" element={<Templates />} />
          <Route exact path="/saveTemplates" element={<SaveTemplate />} />
          <Route exact path="/editTemplates" element={<EditTemplate />} />
          <Route exact path="/viewMedia" element={<ViewMediaFiles />} />
          <Route exact path="/announcements" element={<Announcements />} />
          <Route exact path="/admission" element={<Admission />} />
          <Route exact path="/paymentStatus/:admId/:academicYear" element={<PaymentStatus />} />
          <Route exact path="/nativePaymentStatus/:admId/:academicYear" element={<NativePaymentStatus />}/>
          <Route exact path="/checkout" element={<Checkout />} />
          <Route exact path="/payment/:admId/:academicYear" element={<RazorPay />} />
          <Route exact path="/offlinePaymentStatus" element={<OfflinePaymentStatus />} />
          <Route path="*" element={<Navigate to="/" replace />}/>
        </Routes>
      </div>
    );
  }

  return (
    <div>
      <Routes>
        <Route exact path="/" element={<LoginContainer/>}/>
        <Route exact path="/uploadStudentDetails" element={<UploadStudentsFeeDetailsContainer />} />
        <Route exact path="/viewStudentDetails" element={<ViewStudentDetailsContainer />} />
        <Route exact path="/notifications" element={<Notifications />} />
        <Route exact path="/templates" element={<Templates />} />
        <Route exact path="/saveTemplates" element={<SaveTemplate />} />
        <Route exact path="/editTemplates" element={<EditTemplate />} />
        <Route exact path="/saveMedia" element={<SaveMediaFiles />} />
        <Route exact path="/viewMedia" element={<ViewMediaFiles />} />
        <Route exact path="/announcements" element={<Announcements />} />
        <Route exact path="/admission" element={<Admission />} />
        <Route exact path="/paymentStatus/:admId/:academicYear" element={<PaymentStatus />} />
        <Route exact path="/nativePaymentStatus/:admId/:academicYear" element={<NativePaymentStatus />}/>
        <Route exact path="/checkout" element={<Checkout />} />
        <Route exact path="/payment/:admId/:academicYear" element={<RazorPay />} />
        <Route exact path="/offlinePaymentStatus" element={<OfflinePaymentStatus />} />
        <Route path="*" element={<Navigate to="/" replace />}/>
      </Routes>
    </div>
  );
}

export default App;
